export const SET_IS_SEARCHING = 'SET_IS_SEARCHING'
export const SET_MARKER_ADDRESS = 'SET_MARKER_ADDRESS'
export const CLEAR_MARKER_ADDRESS = 'CLEAR_MARKER_ADDRESS'
export const CLEAR_MARKER_ADDRESS_DONE = 'CLEAR_MARKER_ADDRESS_DONE'
export const SET_LOCATION_ENABLED_WARNING = 'SET_LOCATION_ENABLED_WARNING'
export const INITIALIZE_MAP_WITH_LOCATION = 'INITIALIZE_MAP_WITH_LOCATION'

export const setIsSearching = (value) => ({
  type: SET_IS_SEARCHING,
  value
})

export const setLocationEnabledWarning = (value) => ({
  type: SET_LOCATION_ENABLED_WARNING,
  value
})

export const setMarkerAddress = (value) => ({
  type: SET_MARKER_ADDRESS,
  value
})

export const clearMarkersDone = () => ({
  type: CLEAR_MARKER_ADDRESS_DONE
})

export const initialiseMapWithLocationAction = (location) => ({
  type: INITIALIZE_MAP_WITH_LOCATION,
  location
})
